/**
 * Resolve the effective IndicatorSettings for a given tab.
 *
 * Resolution (highest priority first):
 *   1. Tab-scope override  — ui.byTab[tabId].indicators
 *   2. Built-in default    — DEFAULT_INDICATORS (nothing enabled)
 *
 * IMPORTANT: User scope does NOT cascade here. Indicators are per-chart; a
 * chart with no override shows the built-in default (no indicators) — NOT the
 * user-scope value. The user scope is a saved TEMPLATE only: it's the seed
 * "Customize this chart" / "Copy from User" copies into a tab override. Applying
 * it live would make a user-scope change appear on every chart without its own
 * override (the "enable on one chart enables on all" bug). This mirrors the
 * Weekly Behaviour dialog's user-as-template model, not Fibonacci's live cascade.
 *
 * This is what Chart.tsx renders. Workspace autosave persists the tab scope.
 */

import type { RootState } from "../store";
import { DEFAULT_INDICATORS, type IndicatorSettings } from "../slices/uiSlice";

export function selectEffectiveIndicators(
  state: RootState,
  tabId: string,
): IndicatorSettings {
  return state.ui.byTab[tabId]?.indicators ?? DEFAULT_INDICATORS;
}
